import React from 'react';
import { getStaticImageUrl } from 'client/utils/image-helpers';

export function Photo360Indicator() {
  return (
    <span className="pos-a bg-white-opacity-30 rounded-8 p-1" style={{ margin: '0.5rem' }}>
      <img src={getStaticImageUrl('/icons/360.svg')} alt="" />
    </span>
  );
}
